import { render, staticRenderFns } from "./artice.vue?vue&type=template&id=c79c5d5e&scoped=true&"
import script from "./artice.vue?vue&type=script&lang=js&"
export * from "./artice.vue?vue&type=script&lang=js&"
import style0 from "./artice.vue?vue&type=style&index=0&id=c79c5d5e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79c5d5e",
  null
  
)

export default component.exports